import { render, staticRenderFns } from "./VersionInfo.vue?vue&type=template&id=175e8062&scoped=true&"
import script from "./VersionInfo.vue?vue&type=script&lang=js&"
export * from "./VersionInfo.vue?vue&type=script&lang=js&"
import style0 from "./VersionInfo.vue?vue&type=style&index=0&id=175e8062&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175e8062",
  null
  
)

export default component.exports